import { Injectable } from '@angular/core';
import { User } from '../../login/user';
import { Router } from '@angular/router';
import { isNumber } from 'util';

import { FormGroup, FormControl } from '@angular/forms';

import { HttpClient } from '@angular/common/http';
import { api } from '../../../environments/api';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(private router: Router, private http: HttpClient) {}

    validation(user: FormGroup) {
        return this.http.post(api.url + 'client/login', user.value);
    }

    recoverKey(recoverUser: FormGroup) {
        return this.http.post(api.url + 'clients/recover', recoverUser.value);
    }

    newPassowrd(newPassowrd: FormGroup) {
        return this.http.post(api.url + 'clients/reset_password', newPassowrd.value);
    }

    register(data) {
        return this.http.post( api.url + 'clients', data);
    }

    get isLoggedIn(): boolean {
        return localStorage.getItem('isLoggedIn') === 'true';
    }

    get isSuperAdmin(): boolean {
        return localStorage.getItem('isSuperAdmin') === 'true';
    }

    logout() {
        localStorage.clear();
    }
}
